// 3.9.1 添加用户行为
import axios from '@/http/api'

export const insertUserBehavior = data => {
  return axios({
    url: '/consoleGateway/userInfoController/insertUserBehavior',
    method: 'post',
    data
  })
}
// 3.9.2 获取用户行为
export const selectUserBehavior = data => {
  return axios({
    url: '/consoleGateway/userInfoController/selectUserBehavior',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/monitoring.js